/**
 * Prepend https:// to a user-entered URL that has no protocol.
 *
 * User-entered links (IPE calendly, company websites) pass url_validator with
 * the protocol optional and are stored verbatim; rendering such a value in an
 * href makes the browser resolve it relative to the app origin
 * (elevate-ip.ca/calendly.com/... → 404). Apply this at every render/email
 * site and on save. Empty/undefined stays empty so optional fields render
 * nothing rather than "https://".
 */
export function ensureHttps(url: string | undefined | null): string {
  const trimmed = url?.trim();
  if (!trimmed) return '';
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}
